import axios from "axios";
import { url } from "../config/url";
import { ATTRIBUTE_CREATE_FAILURE, ATTRIBUTE_CREATE_REQUEST, ATTRIBUTE_CREATE_SUCCESS, ATTRIBUTE_DELETE_FAIL, ATTRIBUTE_DELETE_REQUEST, ATTRIBUTE_DELETE_SUCCESS, ATTRIBUTE_GET_FAILURE, ATTRIBUTE_GET_REQUEST, ATTRIBUTE_GET_SUCCESS, ATTRIBUTE_LIST_FAILURE, ATTRIBUTE_LIST_REQUEST, ATTRIBUTE_LIST_SUCCESS, ATTRIBUTE_UPDATE_FAILURE, ATTRIBUTE_UPDATE_REQUEST, ATTRIBUTE_UPDATE_SUCCESS } from "../constants/attributeConstants";

import { logout } from "./userActions";

export const createAttribute = (name, status) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTRIBUTE_CREATE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.post(
      `${url}/attributes`,
      { name, status },
      config
    );
    dispatch({
      type: ATTRIBUTE_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ATTRIBUTE_CREATE_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listAttributes = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: ATTRIBUTE_LIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${url}/attributes`, config);

    dispatch({
      type: ATTRIBUTE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    console.log(message);

    dispatch({
      type: ATTRIBUTE_LIST_FAILURE,
      payload: message,
    });
  }
};

export const getAttribute = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ATTRIBUTE_GET_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${url}/attributes/${id}`, config);

    dispatch({
      type: ATTRIBUTE_GET_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    console.log(message);

    dispatch({
      type: ATTRIBUTE_GET_FAILURE,
      payload: message,
    });
  }
};

export const updateAttribute = (Attribute) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTRIBUTE_UPDATE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    const { data } = await axios.put(
      `${url}/attributes/${Attribute._id}`,
      Attribute,
      config
    );
    dispatch({
      type: ATTRIBUTE_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: ATTRIBUTE_UPDATE_FAILURE,
      payload: message,
    });
  }
};

export const deleteAttribute = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ATTRIBUTE_DELETE_REQUEST,
    });
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
    await axios.delete(`${url}/attributes/${id}`, config);
    dispatch({
      type: ATTRIBUTE_DELETE_SUCCESS,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: ATTRIBUTE_DELETE_FAIL,
      payload: message,
    });
  }
};
